import moment from 'moment';
import omit from 'lodash/omit';
import {DateField} from '@mui/x-date-pickers/DateField';

import CustomInput from './CustomInput';

const handleChange = ({onChange}) => momentObj => {
  const dateStr = momentObj.format('yyyy-MM-DD');
  if (onChange) {
    onChange({target: {value: dateStr}}, dateStr);
  }
};

const SimpleDateField = props => {
  return (
    <CustomInput
      {...props}
    >
      <DateField
        {...omit(props, 'label', 'helperText')}
        defaultValue={
          props.defaultValue
            ? moment(props.defaultValue)
            : null
        }
        onChange={handleChange({onChange: props.onChange})}
      />
    </CustomInput>
  );
};

export default SimpleDateField;